import React, { Component } from 'react';
import "./hero.css";
import { Link } from "react-router-dom";

export default class Hero extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: ''
      };
  }

  componentDidMount = () => {
    setTimeout(function() {
      this.setState(
				{
					componentReady: 'ready'
				}
		);

    }.bind(this), 10);
  }
  render() {
    var tint = 'rgba(0,0,0,0)';
    if(this.props.tint == "dark"){
      tint = 'rgba(0,0,0,.4)';
    }
    var image = this.props.backgroundImage;
    if(window.innerWidth <= 800 && this.props.mobileImage){
      image = this.props.mobileImage;
    }
    return (
      <div className={this.props.extraClassName}>
        <div className={this.state.componentReady}>
          <div className={`hero ${ this.props.height }`}>
            <div id="hero-parallax" className="hero-content">
              {this.props.icon && <img className="half-width" src={this.props.icon} style={{maxWidth:"150px"}} />}
              {this.props.subtitlePosition == "top" && <h5 className="hero-subtitle uppercase full-width">{this.props.subtitle}</h5>}
              <h1 className="hero-title full-width">{this.props.title}</h1>
              {this.props.subtitlePosition != "top" && <h5 className="hero-subtitle uppercase full-width tiny-padding">{this.props.subtitle}</h5>}
              {this.props.description && <p className="small-max-width-container white"><b>{this.props.description}</b></p>}
              {this.props.link && <Link className="button" to={this.props.link} style={{marginTop:'30px'}}><b>{this.props.linkText}</b></Link>}
            </div>
            <div className="hero-tint" style={{backgroundColor:tint}}></div>
            <div className="hero-background" style={{backgroundImage: "url(" + image + ")"}}></div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/hero/index.js